import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    //name: 'Home',
    //component: Home
    redirect:'/login'
  },
  {
    path: '*',
    component: () => import( '@/views/404.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import( '@/views/login/Login.vue')
  },
  {
    path: '/home',
    meta: {requiresAuth: true},
    component: () => import('@/views/secret/Home.vue'),
    children:[
      {
        path: 'datosrci',
        component: () => import( '@/views/secret/datosrci/DatosRci.vue')
      },
      {
        path: 'datosregio', 
        component:() => import('@/views/secret/datosregio/RegioColor.vue')
      },
      {
        path: 'formulario-ventas',
        meta: {requiresRol: 2},
        component: () => import( '@/views/secret/vendedor/Formulario.vue')
      },
      {
        path: 'listado-ventas', 
        component: () => import( '@/views/secret/vendedor/Listado.vue')
      },
      {
        path: 'listado-ventas-cerrada', 
        component: () => import( '@/views/secret/vendedor/ListadoCerrada.vue')
      },
      {
        path: 'crear_usuarios',
        meta: { requiresAdmin: true},
        component: () => import( '@/views/secret/admin/CreateUsers.vue')
      },
      {
        path: 'roles',
        meta: { requiresAdmin: true},
        component: () => import( '@/views/secret/admin/Roles.vue')
      },
      {
        path: 'usuarios',
        meta: { requiresAdmin: true},
        component: () => import( '@/views/secret/admin/Users.vue')
      },
      {
        path: 'usuarios_inactivos',
        meta: { requiresAdmin: true},
        component: () => import( '@/views/secret/admin/InactiveUsers.vue')
      },
      {
        path: 'editar_usuarios',
        meta: { requiresAdmin: true},
        component: () => import( '@/views/secret/admin/UpdateUsers.vue')
      },
      {
        path: 'editar_roles',
        meta: { requiresAdmin: true},
        component: () => import( '@/views/secret/admin/UpdateRoles.vue')
      },
      {
        path: 'listado-preprensa', 
        component: () => import( '@/views/secret/preprensa/Listado.vue')
      },
      {
        path: 'historico-preprensa', 
        component: () => import( '@/views/secret/preprensa/Historico.vue')
      },
      {
        path: 'listado-ingenieria', 
        component: () => import( '@/views/secret/ingenieria/Listado.vue')
      },
      {
        path: 'historico-ingenieria', 
        component: () => import( '@/views/secret/ingenieria/Historico.vue')
      },
      {
        path: 'bitacoracd74',
        component: () => import('@/views/secret/bitacoracd74/Listado.vue')
      },
      {
        path: 'cierreordenfabricacion',
        component: ()=> import('@/views/secret/cierreordenfabricacion/Listado.vue')
      },
      {
        path: 'bitpegadora',
        component: ()=> import('@/views/secret/bitpegadora/Listado.vue')
      },
      {
        path: 'bittroqueladora3',
        component: ()=> import('@/views/secret/bittroqueladora3/Listado.vue')
      },
      {
        path: 'bittroqueladoran1',
        component: ()=> import('@/views/secret/bittroqueladoran1/Listado.vue')
      },
      //Guillotina
      {
        path: 'guillotina',
        component: ()=> import('@/views/secret/guillotina/Listado.vue')
      },
      //Bobst106
      {
        path: 'bobst106',
        component: ()=> import('@/views/secret/bobst106/Listado.vue')
      },
      
      //ofdatosRCI
      {
        path: 'ofdatosrci',
        component: () => import( '@/views/secret/ofdatosrci/DatosRci.vue')
      },
      {
        path: 'ofdatosregio', 
        component:() => import('@/views/secret/ofdatosregio/RegioColor.vue')
      },
      //Reportes
      {
        path: 'poroperador', 
        component:() => import('@/views/secret/reportes/Operador.vue')
      },
      {
        path: 'pormaquina', 
        component:() => import('@/views/secret/reportes/Maquina.vue')
      },
      {
        path: 'pororden', 
        component:() => import('@/views/secret/reportes/Orden.vue')
      },
      {
        path: 'porturno', 
        component:() => import('@/views/secret/reportes/Turno.vue')
      },
      {
        path: 'filtroporof', 
        component:() => import('@/views/secret/maquinas/FiltroOf.vue')
      },
      //Tickets
      {
        path: 'crearticket',
        component:() => import('@/views/secret/ticket/CrearTicket.vue')
      },
      {
        path: 'consultarticket',
        component:() => import('@/views/secret/ticket/ConsultarTicket.vue')
      },
      {
        path: 'ticketDashboard',
        component:() => import('@/views/secret/ticket/Dashboard.vue')
      },
      
      {
        path: 'ticketAttendant',
        component:() => import('@/views/secret/ticket/AtenderTicket.vue')
      },
      {
        path: 'etiquetas',
        meta: { requiresAdmin: true},
        component: () => import( '@/views/secret/admin/Etiquetas.vue')
      },
      {
        path: 'ticketActivities',
        component:() => import('@/views/secret/ticket/ActivitiesTicket.vue')
      },
      {
        path: 'dropbox',
        component:() => import('@/views/secret/dropbox/dropbox.vue')
      },
      
    ]
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const isLogged =  store.state.login.isLogged
  const rol_id = store.state.login.rol_id
  //const isLogged = localStorage.getItem('isLogged')
  
  
  /**
   * Si el usuario no es administrador lo redireccion a home.
   */
  if(requiresAuth && isLogged && requiresAdmin  && rol_id != 1){
    next('/home')
  }
  if(!requiresAuth && isLogged  && to.path === '/login'){
    next('/home')
  }
  if(requiresAuth && !isLogged){
    next('/login')
  }else{
    next()
  }
  

})

export default router
